import * as React from "react";
const SVGComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    {...props}
  >

    <path
      d="M 361.255 282.268 L 361.255 288.056 C 361.255 370.839 361.255 412.21 335.78 437.933 C 310.328 463.633 269.332 463.633 187.369 463.633 C 105.406 463.633 64.415 463.633 38.94 437.933 C 13.487 412.21 13.487 370.839 13.487 288.056 L 13.487 200.269 C 13.487 117.511 13.487 76.139 38.94 50.418 C 64.415 24.695 105.406 24.695 187.369 24.695 C 269.332 24.695 295.891 24.253 317.136 53.507"
      strokeLinecap="round"
      style={{
        stroke: "rgb(0, 0, 0)",
        strokeWidth: 15,
        fill: "rgb(91, 54, 193)",
      }}
    />
    <path
      d="M 222.555 143.345 C 222.555 167.595 203.08 187.237 179.084 187.237 C 155.066 187.237 135.614 167.595 135.614 143.345 C 135.614 119.115 155.066 99.448 179.084 99.448 C 203.08 99.448 222.555 119.115 222.555 143.345 Z"
      stroke="#1C274C"
      style={{
        fill: "rgb(255, 255, 255)",
        strokeWidth: 14,
      }}
    />
    <path
      d="M 278.471 328.701 C 278.471 377.864 236.989 417.713 185.816 417.713 C 134.639 417.713 93.163 377.864 93.163 328.701 C 93.163 279.568 134.639 239.691 185.816 239.691 C 236.989 239.691 278.471 279.568 278.471 328.701 Z"
      stroke="#1C274C"
      style={{
        strokeWidth: 14,
        fill: "rgb(255, 255, 255)",
      }}
    />
    <path
      d="M 427.791 87.459 L 427.791 164.009 M 375.314 112.976 L 375.314 164.009 M 322.84 138.49 L 322.84 164.009 M 493.424 125.733 C 493.424 189.142 440.569 240.555 375.357 240.555 C 348.648 240.555 257.303 240.555 257.303 240.555 C 257.303 240.555 277.754 192.789 269.568 176.766 C 261.711 161.392 257.288 144.067 257.288 125.733 C 257.288 62.313 310.155 10.91 375.357 10.91 C 440.569 10.91 493.424 62.313 493.424 125.733 Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{
        strokeWidth: 10,
        stroke: "rgb(28, 39, 76)",
        fill: "rgb(166, 90, 240)",
      }}
    />
    <ellipse
      style={{
        fill: "rgb(28, 39, 76)",
        stroke: "rgb(91, 54, 193)",
      }}
      cx={186.609}
      cy={331.591}
      rx={33.863}
      ry={32.537}
    />
  </svg>
);
export default SVGComponent;
